const BASE = "/vadmin";

const SEGMENTS: Record<string, string> = {
  "/vadmin": "Dashboard",
  "/vadmin/integrari": "Integrations",
  "/vadmin/setari": "Site settings",
  "/vadmin/utilizatori": "Users",
  "/vadmin/log": "Activity log",
  "/vadmin/clienti": "Clients",
  "/vadmin/clienti/grupuri": "Client groups",
  "/vadmin/clienti/notificari": "Client notifications",
  "/vadmin/clienti/influencer-rates": "Influencer rates",
  "/vadmin/clienti/influencer-payouts": "Influencer payouts",
  "/vadmin/produse": "Products",
  "/vadmin/produse/oferte": "Product offers",
  "/vadmin/produse/recenzii": "Product reviews",
  "/vadmin/produse/transport": "Product shipping",
  "/vadmin/comenzi": "Orders",
  "/vadmin/comenzi/returnare": "Returns",
  "/vadmin/comenzi/vouchere": "Vouchers",
  "/vadmin/continut": "Content",
  "/vadmin/continut/casute": "Homepage boxes",
  "/vadmin/continut/carusel": "Homepage carousel",
  "/vadmin/continut/anunturi": "Announcements",
  "/vadmin/continut/faq": "FAQ",
  "/vadmin/seo": "SEO"
};

export function adminBreadcrumbs(pathname: string): {href: string; label: string}[] {
  if(pathname === BASE || pathname === `${BASE}/`) {
    return [{href: BASE, label: SEGMENTS[BASE]}];
  }
  const parts = pathname.replace(BASE, "").split("/").filter(Boolean);
  const crumbs: {href: string; label: string}[] = [{href: BASE, label: "Dashboard"}];
  let acc = BASE;
  for(const part of parts) {
    acc += `/${part}`;
    const label = SEGMENTS[acc];
    if(label) crumbs.push({href: acc, label});
  }
  return crumbs;
}

export function adminPageTitle(pathname: string): string {
  if(SEGMENTS[pathname]) return SEGMENTS[pathname];
  const match = Object.entries(SEGMENTS).sort((a, b) => b[0].length - a[0].length).find(([path]) => pathname.startsWith(path));
  return match?.[1] || "Administration";
}
